import React from "react";
import { Validators } from "Utils/Constants";
import MaskedField from "Components/Fields/MaskedField";
import { Box, useMediaQuery, useTheme } from "@mui/material";

export default function IdentificationFields({
  onFieldChange = (fieldName, fieldValue, isValid) => {
    console.warn("onFieldChange not set.");
  },
  disabled = false,
  errorMessage,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <Box>
      <MaskedField
        fieldName="ssn"
        label="SSN#"
        mask="999-99-9999"
        maxLength={9}
        required={true}
        autoComplete="off"
        validators={[Validators.SSN]}
        onValueChanged={onFieldChange}
        disabled={disabled}
      />
    </Box>
  );
}
